<template>
    <div>
        <Card class="pay-content" id="paycard" style="border:1px solid #d6bb5c;height: 410px;overflow-y: auto;">
            <!--   <div class="actionPayTitle"></div> -->
            <div slot="title">
                <p class="pay-title">{{currentPurchaseData?currentPurchaseData.name:''}}</p>
                <p class="card-explain" style="color:#808695">{{currentPurchaseData?currentPurchaseData.desc:''}}</p>
            </div>
            <div style="display: inline-block;width:80%;">
                <Row style="background:white;padding:5% 5% 5% 1%;">
                    <Col v-for="item in cardOptions" :span="cardOptions.length===3?'7':cardOptions.length===2?'11':cardOptions.length===1?'23':'23'" :key="item.discountcode" offset="1">
                    <div :class="item.selected?'optionscard-select':'optionscard'" @click="cardSelect(item.discountcode)">
                        <div style="font-size:16px;font-weight: bold;color:#17233d;text-align: center;">{{item.salenumber}}年</div>
                        <div style="font-size:12px;color:#ed4014;">{{item.discountname}}</div>
                        <div style="height:1px;line-height: 1px;background-color:#dcdee2;margin:5px 0px;"></div>
                        <div style="font-size:14px;color:#ed4014;">
                            <span style="font-size: 14px;">{{item.discountdesc}}</span>
                        </div>
                        <Icon color="#19be6b" size="16" class="select-icon" type="md-checkmark-circle" :style="{display:item.selected?'block':'none'}" />
                    </div>
                    </Col>
                </Row>
            </div>
            <div class="divline">
                <span class="divtxt">配置</span>
            </div>
            <p class="pay-explain" style="font-size: 14px;">
                <div v-if="modalPurchase1" style="padding:5px;margin: 0px 30px;">
                    <div v-for="(list,index) in currentPurchaseData.BasePackageFun" :key="index" style="float: left;">
                        <Tag size="medium" v-if="list.code==='000009'" color="green">{{ list.alias }}</Tag>
                        <Tag size="medium" v-else color="orange">{{ list.alias }}</Tag>
                    </div>
                </div>
            </p>
        </Card>
        <div class="pay-change">
            <p style="height:30px;">支付方式</p>
            <RadioGroup v-model="payChange">
                <Radio label="微信" border>
                    <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                    <span style="color: #19c105;">微信</span>
                </Radio>
                <!-- <Radio label="支付宝" border>
                        <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                        <span style="color: #00aaee;">支付宝</span>
                    </Radio> -->
            </RadioGroup>
        </div>
        <div class="invoiceContent">
            <span>发票信息：</span>
            <span v-if="invoiceType===1">普通发票</span>
            <span v-else-if="invoiceType===2">增值税专用发票</span>
            <span>{{sonheadertype===1?'个人':'单位'}}</span>
            <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
        </div>
        <Divider orientation="center">优惠信息</Divider>
            <div style="text-align:right;padding-right: 10%;height: 160px;">
                <Coupon style="float:left;padding-left:10%;" ref="mycoupon" @on-check="onCouponChecked" :isCouponShow="this.currentPurchaseData&&this.currentPurchaseData.code==='000001'?false:true" :isAgentShow=true />
                <div style="color:red;font-size: 18px;text-align: right;margin-right: 25px;margin-top: 25px;display: block;float:right;">
                <span style="margin-right: 20px;vertical-align: middle;">实际支付:{{totalBill}}元</span>
                <Button type="primary" class="pay-btn" @click="directPay">去支付</Button>
            </div>
            </div>

        <Modal v-model="modalInvoice" width="700" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref='myInvoice' :isModal="true" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">提交</Button>
            </div>
        </Modal>
        <QR ref="QRPayModal" @paySuccess="payComplete" @showAgreement="showPackageAgreement" />
        <Agreement ref="product_agreement" :isConfirm="true" @onAccept="onAgreementAccept" />
    </div>
</template>
<script>
import invoice from './myinvoice.vue'
import coupon from './coupon.vue'
import qrModal from './qrpay.vue'
import ProductAgreement from './product_agreement.vue'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    props: {
        pData: Object,
        cardData: Array,
    },
    data() {
        return {
        	memberLevelChkInfo: null,
        	orderid: '',
            base64str: '',
        	promocode: {
                couponcode: '',
                agentcode: '',
            },
        	totalBill:0,
        	oriprice:0,
        	modalInvoice:false,
            currentPurchaseData: {},
            cardOptions: [],
            modalPurchase1: false,
            payChange: '微信',
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",
            },
            invoiceType: 1,
            invoiceHeaderName: '个人',
            currentDiscountData:null,
        }
    },
    created() {

    },
    components: {
        'Invoice': invoice,
        'Coupon': coupon,
        'QR': qrModal,
        'Agreement': ProductAgreement,
    },
    methods: {
    	 //用户等级包下单
        takeOrder() {
            console.log(this.currentPurchaseData)
            let product = this.currentPurchaseData
            let discountData = this.currentDiscountData
            this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies
            //console.log(product, discountData)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                product: product.code,
                discount: discountData.discountcode,
                paytype: 30,
                couponcode: this.promocode.couponcode,
                agentcode: this.promocode.agentcode,
                invoice: _invoice,

            }
            //用户等级包下单
            constJ.reqCreateOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //绑定支付二维码
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    this.totalBill = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: this.totalBill, 
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)

                } else {
                    //更新产品列表,当前产品已购买
                    this.$Message.warning(res.rltdesc)
                    //console.log('您已购买过此产品')
                    return
                }
            })
        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('获取升级包合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    this.$refs.product_agreement.createdata(res.item)
                }
            })
        },
    	onAgreementAccept() {
            console.log("onAgreementAccept1======>")
        },
    	showPackageAgreement() {
            this.$refs.product_agreement.show()
        },
    	payComplete() {
            console.log('支付完成===>')
            this.$emit('payComplete')
        },
        //下单前检查优惠码和运营商信息,可以强制下单
        checkOrder() {
            let r = this.$refs.mycoupon.getConfirmInfo()
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "返回",
                    okText: "下单",
                    onOk: () => {
                        this.takeOrder()
                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.takeOrder()
            }
        },
    	directPay() {
            console.log('show qrcode')
            this.checkOrder()
            //this.showQRAndCheckPayStatus()
        },
    	showCouponPrice(value) {
            this.totalBill = value.item.amount
            this.oriprice = value.item.oriamount
            // this.newprice=value.item.amount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.totalBill, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()
                //this.goPurchase(this.currentPurchaseData)
            }
        },
    	cancelInvoice() {
            this.modalInvoice = false
        },
        getInvoiceInfo() {
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if(this.$refs.myInvoice.formData.headertype == 1){
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    //this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    // console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        showInvoice() {
            this.modalInvoice = true
            this.$refs.myInvoice.invoicetype = '1'
            //this.$refs.myInvoice.invoiceTotal = this.totalBill
        },
        show(pdata, cOption) {
            console.log('products show===>')
            console.log(pdata, cOption)
            this.currentPurchaseData = pdata
            this.cardOptions = cOption
            this.modalPurchase1 = true

            this.cardOptions[0].selected = true
            this.totalBill = this.cardOptions[0].newprice
            this.oriprice = this.cardOptions[0].oriprice
            this.currentDiscountData = this.cardOptions[0]

            this.$refs.myInvoice.getInvoice()
            //清空coupon信息
            this.$refs.mycoupon.clean()
        },
        cardSelect(id) {
            console.log('cardSelect======>')
            // this.cardOptions.forEach(function(item) {
            //     item.selected = false
            // })
            // const findelement = this.cardOptions.find(element => element.id === id)
            // findelement.selected = true
            // this.payTime = findelement.time
            // this.discount = findelement.discount
            // this.currentPurchaseData.remainingday = 365 * this.payTime
            // this.currentPurchaseData.orderYears = this.payTime
            // this.currentPurchaseData.expirationDate = moment().add(this.currentPurchaseData.remainingday, 'days').format("YYYY-MM-DD");
            console.log(id)
            this.cardOptions.forEach(function(item) {
                item.selected = false
            })
            const findelement = this.cardOptions.find(element => element.discountcode === id)
            findelement.selected = true
            let _index = this.cardOptions.findIndex(element => element.discountcode === id)
            this.$set(this.cardOptions, _index, findelement)
            console.log(findelement)
            this.totalBill = findelement.newprice
            this.oriprice = findelement.oriprice
            this.currentDiscountData = findelement

            //切换账号等级年限
            if (this.memberLevelChkInfo && this.memberLevelChkInfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.totalBill, this.showCouponPrice)
            }
            //console.log(this.cardOptions)

        },
    }
}
</script>
<style lang="less" scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}

.card-explain {
    text-align: center;
    line-height: 12px;
    font-size: 12px;
    height: 15px;
}

.card-btn-main {
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.card-body {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
}



.pay-content {
    border: 1px solid #ccc;
    margin: 1% 10%;
    padding: 1% 5%;
    text-align: center;
}

.pay-title {
    font-size: 20px;
    color: #f55d54;
    height: 30px;
}

.pay-change {
    text-align: center;
}

.pay-explain {
    height: 5px;
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    margin-top: 0px;
}


#paycard {
    background-color: #FEE5A7;
    overflow: hidden;
}

#paycard/deep/.ivu-card-head {
    /*border-bottom: 1px solid #e0cc98;*/
    border-bottom: none;
}

#paycard/deep/.ivu-card-body {
    padding: 0px !important;
}



/*分割线*/
.divline {
    display: table;
    white-space: nowrap;
    text-align: center;
    background: 0 0;
    font-weight: 500;
    color: #17233d;
    font-size: 16px;
    margin: 6px 0;
}

.divline:before {
    content: '';
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid #ed4014;
    transform: translateY(50%);
}

.divline:after {
    content: '';
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid #ed4014;
    transform: translateY(50%);
}

.divtxt {
    display: inline-block;
    padding: 0 24px;
    font-size: 14px;

}

.optionscard {
    display: grid;
    border: 1px solid #dcdee2;
    padding: 20px;
    cursor: Pointer;
}

.optionscard-select {
    background-color: #FFF1F3;
    display: grid;
    border: 1px solid #ed4014;
    padding: 20px;
    cursor: Pointer;
}

.select-icon {
    position: absolute;
    bottom: 5px;
    left: 90%;
}



/*发票信息*/
.invoiceContent {
    margin-top: 10px;
    text-align: center;
    padding-right: 22px;

    span {
        padding-left: 10px;
    }
}
</style>